// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.commonSelectTime{
    position: relative;
    width: 100px;
    --item-height: 30px;
    font-size: calc(10px * var(--fontScaler));
    z-index: 1;
}

.commonSelectTime--collapsed{
    z-index: 0;
}

.commonSelectTime_scrollList_item{
    height: var(--item-height);
    width: 100%;
    background-color: #fff;
    display: flex;
    align-items: center;
    justify-content: center;
    cursor: default;
    flex-shrink: 0;
    /*transform: translateY(50%);*/
}

.commonSelectTime_scrollList_item:hover{
    /*background-color: #f6f6f9;*/
    background-color: #f9f9f6;
}

.commonSelectTime_scrollList{
    position: absolute;
    width: 100%;
    height: 100%;
    top: 0;
    left: 0;
}

.commonSelectTime_scrollList_items{
    transform: translateY(calc(-50% + var(--item-height) / 2));
    padding: 10px 0px;
    background-color: #fff;
    border-radius: 10px;
    box-shadow: 0px 0px 10px #0003;
    display: flex;
    transition-duration: 200ms;
}

.commonSelectTime_scrollList_collapser{
    width: 100%;
    height: calc(var(--item-height) * 7);
    display: flex;
    flex-direction: column;
    justify-content: center;
    overflow: hidden;
    transition-duration: 200ms;
}

.commonSelectTime--collapsed .commonSelectTime_scrollList_collapser{
    height: calc(var(--item-height) - 20px);
}

.commonSelectTime_selectionBorder{
    height: var(--item-height);
    border: 1px solid #0003;
    position: relative;
    background-color: transparent;
    transform: translateY(0);
    border-radius: 4px;
    box-shadow: 0px 0px 10px #0003;
}

.commonSelectTime--collapsed .commonSelectTime_selectionBorder{
    box-shadow: 0px 0px 0px #0000;
}

.commonSelectTime--collapsed .commonSelectTime_scrollList_items{
    box-shadow: 0px 0px 0px #0000;
}`, "",{"version":3,"sources":["webpack://./src/components/selectTime/SelectTime.css"],"names":[],"mappings":"AAAA;IACI,kBAAkB;IAClB,YAAY;IACZ,mBAAmB;IACnB,yCAAyC;IACzC,UAAU;AACd;;AAEA;IACI,UAAU;AACd;;AAEA;IACI,0BAA0B;IAC1B,WAAW;IACX,sBAAsB;IACtB,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,eAAe;IACf,cAAc;IACd,8BAA8B;AAClC;;AAEA;IACI,6BAA6B;IAC7B,yBAAyB;AAC7B;;AAEA;IACI,kBAAkB;IAClB,WAAW;IACX,YAAY;IACZ,MAAM;IACN,OAAO;AACX;;AAEA;IACI,0DAA0D;IAC1D,iBAAiB;IACjB,sBAAsB;IACtB,mBAAmB;IACnB,8BAA8B;IAC9B,aAAa;IACb,0BAA0B;AAC9B;;AAEA;IACI,WAAW;IACX,oCAAoC;IACpC,aAAa;IACb,sBAAsB;IACtB,uBAAuB;IACvB,gBAAgB;IAChB,0BAA0B;AAC9B;;AAEA;IACI,uCAAuC;AAC3C;;AAEA;IACI,0BAA0B;IAC1B,uBAAuB;IACvB,kBAAkB;IAClB,6BAA6B;IAC7B,wBAAwB;IACxB,kBAAkB;IAClB,8BAA8B;AAClC;;AAEA;IACI,6BAA6B;AACjC;;AAEA;IACI,6BAA6B;AACjC","sourcesContent":[".commonSelectTime{\n    position: relative;\n    width: 100px;\n    --item-height: 30px;\n    font-size: calc(10px * var(--fontScaler));\n    z-index: 1;\n}\n\n.commonSelectTime--collapsed{\n    z-index: 0;\n}\n\n.commonSelectTime_scrollList_item{\n    height: var(--item-height);\n    width: 100%;\n    background-color: #fff;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    cursor: default;\n    flex-shrink: 0;\n    /*transform: translateY(50%);*/\n}\n\n.commonSelectTime_scrollList_item:hover{\n    /*background-color: #f6f6f9;*/\n    background-color: #f9f9f6;\n}\n\n.commonSelectTime_scrollList{\n    position: absolute;\n    width: 100%;\n    height: 100%;\n    top: 0;\n    left: 0;\n}\n\n.commonSelectTime_scrollList_items{\n    transform: translateY(calc(-50% + var(--item-height) / 2));\n    padding: 10px 0px;\n    background-color: #fff;\n    border-radius: 10px;\n    box-shadow: 0px 0px 10px #0003;\n    display: flex;\n    transition-duration: 200ms;\n}\n\n.commonSelectTime_scrollList_collapser{\n    width: 100%;\n    height: calc(var(--item-height) * 7);\n    display: flex;\n    flex-direction: column;\n    justify-content: center;\n    overflow: hidden;\n    transition-duration: 200ms;\n}\n\n.commonSelectTime--collapsed .commonSelectTime_scrollList_collapser{\n    height: calc(var(--item-height) - 20px);\n}\n\n.commonSelectTime_selectionBorder{\n    height: var(--item-height);\n    border: 1px solid #0003;\n    position: relative;\n    background-color: transparent;\n    transform: translateY(0);\n    border-radius: 4px;\n    box-shadow: 0px 0px 10px #0003;\n}\n\n.commonSelectTime--collapsed .commonSelectTime_selectionBorder{\n    box-shadow: 0px 0px 0px #0000;\n}\n\n.commonSelectTime--collapsed .commonSelectTime_scrollList_items{\n    box-shadow: 0px 0px 0px #0000;\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
